<template>
	<footer class="footer">
		<div class="footer-content">
			<p>
				ТОВ "ЕЙСІ ДІСІ ПРОЦЕССІНГ"
				<br>Повідомлення про внесення відомостей до РПІ: №27-0018/15761 від 22.03.2019
				<br>Важливий технологічний оператор платіжних послуг
			</p>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer'
	};
</script>

<style scoped lang="less">
	.footer{
		min-width: 100%;
		background-color: #fbfbfb;
		padding: 24px 0 ;
	}
	.footer-content{
		max-width: 960px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.8em;

	}
</style>
